import React, { useEffect, useRef, useState } from 'react';
import { Modal, Card, message } from 'antd';
import HlsJsPlayer from 'xgplayer-hls.js';
import Player from 'xgplayer';
import * as poseDetection from '@tensorflow-models/pose-detection';
import * as params from './params';
import { STATE } from './params';
import { drawPerson, resetMatchmanFilters } from './matchman';

import { PoseDetector } from './poseDetector';

const ModalVideo = (props) => {
  // eslint-disable-next-line react/prop-types
  const { src, visible, onCancel, title } = props;
  const ref = useRef();
  const [player, setPlayer] = useState();
  const [model, setModel] = useState();
  const [detectorConfig, setDetectorConfig] = useState();
  const [detector, setDetector] = useState();
  const [renderFrame, setRenderFrame] = useState();
  const [isEnded, setIsEnded] = useState(false);
  const [isPlaying, setIsPlaying] = useState(true);

  const MOVENET_URL_THUNDER =
    'https://litta-prd-1301594083.cos.ap-nanjing.myqcloud.com/litta-resources/litta-mini/transfer/model_1.json';
  //图像推理置信度底值
  const EstimateScore = 0.5;
  const IMG_URL =
    'https://litta-prd-1301594083.cos.ap-nanjing.myqcloud.com/front/738632db-472a-4177-a949-23076bacd0814410t.jpg';

  // const model = poseDetection.SupportedModels.MoveNet;
  // const detector = await poseDetection.createDetector(model);

  const canvas = document.createElement('canvas'); // 创建canvas元素
  const canvasCtx = canvas.getContext('2d', { willReadFrequently: true });

  let videoElement1 = null;
  let canvasElement1 = null;

  let lastFrameTime = 0;
  let isDetecting = false;
  let lostFrames = 0;

  // async function renderPrediction() {
  //   await renderResult();
  // };

  useEffect(() => {
    if (visible) {
      playVideo();
    } else {
      player?.pause();
      player?.destroy();
    }
  }, [ref, src, visible]);

  useEffect(() => {
    loadModel();
  }, []);

  /**
   * 加载模型
   */
  async function loadModel() {
    // {
    //   const model = poseDetection.SupportedModels.MoveNet
    //   setModel(model);
    // const detectorConfig = {
    //   // modelType: poseDetection.movenet.modelType.SINGLEPOSE_LIGHTNING,
    //   // modelUrl: MOVENET_URL_LIGHTING,
    //   modelType: poseDetection.movenet.modelType.SINGLEPOSE_THUNDER,
    //   modelUrl: MOVENET_URL_THUNDER,
    //   minPoseScore: EstimateScore,
    //   // multiPoseMaxDimension: 192,
    // }
    //   setDetectorConfig(detectorConfig);
    // // }

    //  const detector = poseDetection.createDetector(model, detectorConfig)
    //  setDetector(detector);
    // this._warmUp()
    // .catch((err) => {
    //   console.error('createDetector error:', err)
    //   detector = poseDetection.createDetector(
    //     model,
    //     detectorConfig
    //   )
    // })
    // console.log('poseDetector:', this.detector)

    const model = poseDetection.SupportedModels.MoveNet;
    const detectorConfig = {
      // modelType: poseDetection.movenet.modelType.SINGLEPOSE_LIGHTNING,
      // modelUrl: MOVENET_URL_LIGHTING,
      modelType: poseDetection.movenet.modelType.SINGLEPOSE_LIGHTNING,
      modelUrl: MOVENET_URL_THUNDER,
      minPoseScore: EstimateScore,
      // multiPoseMaxDimension: 192,
    };
    const detector = await poseDetection.createDetector(model, detectorConfig);

    // 预热模型 (Warm-up)
    // TFJS 第一次推理时需要同步编译大量的 WebGL Shaders，会造成主线程阻塞。
    // 在这里我们用一个空白的离屏 Canvas 提前触发一次空推理，将卡顿在后台加载阶段“消化”掉，
    // 这样在视频真正开始播放的第一帧时，就不会再出现明显的页面卡顿了。
    try {
      const warmUpCanvas = document.createElement('canvas');
      warmUpCanvas.width = 192;
      warmUpCanvas.height = 192;
      await detector.estimatePoses(warmUpCanvas);
    } catch (e) {
      console.error('Model warm-up error:', e);
    }

    setDetector(detector);
  }

  function createPlayerConfig() {
    return {
      id: 'player',
      url: src,
      autoplay: true,
      playbackRate: [0.5, 0.75, 1, 1.5, 2],
      muted: true,
      screenShot: {
        saveImg: true,
        quality: 1,
        type: 'image/png',
        format: '.png',
      },
      cssFullscreen: true, // 网页样式全屏
      fluid: true,
      enableContextmenu: true, // 右键菜单
      volume: 0.0,
    };
  }

  const playVideo = () => {
    resetMatchmanFilters();
    if (!src) {
      message.warn('视频URL为空！');
      return;
    }
    setTimeout(function () {
      // eslint-disable-next-line react/prop-types
      // if (src.toLowerCase().endsWith('.m3u8')) {
      //   // eslint-disable-next-line no-new
      //   const player = new HlsJsPlayer(createPlayerConfig());
      //   setPlayer(player);
      //   renderResult();
      // } else {
      //   // eslint-disable-next-line no-new
      //   const player = new Player(createPlayerConfig());
      //   setPlayer(player);
      //   renderResult();
      // }
      const videoElement = document.getElementById('videotest');
      const canvasElement = document.getElementById('output');
      videoElement1 = videoElement;
      canvasElement1 = canvasElement;

      videoElement.src = src;
      videoElement.crossOrigin = 'anonymous';
      videoElement.autoplay = true;
      videoElement.muted = true;

      setIsEnded(false);
      setIsPlaying(true);
      videoElement.onended = () => {
        setIsEnded(true);
        setIsPlaying(false);
      };

      videoElement.addEventListener(
        'loadedmetadata',
        function () {
          canvasElement.width = videoElement.videoWidth;
          canvasElement.height = videoElement.videoHeight;

          // 请求第一帧图像
          videoElement.requestVideoFrameCallback(drawFrame);
        },
        100,
      );
      // video.addEventListener('loadedmetadata', () => {
      //   const canvas = document.createElement('canvas');
      //   const ctx = canvas.getContext('2d');
      //   canvas.width = video.videoWidth;
      //   canvas.height = video.videoHeight;
      //   const renderFrame = () => {
      //     ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      //     // const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      //     // process imageData here
      //     video.requestVideoFrameCallback(renderFrame);
      //     // setRenderFrame(renderFrame);
      //     // console.log(renderFrame)
      //   };
      //   video.requestVideoFrameCallback(renderFrame);
      //   console.log(renderFrame)
      //   }, 100);
    });
  };

  async function drawFrame(now, metadata) {
    // 如果当前时间与上一帧时间相同，则跳过该帧
    if (now === lastFrameTime) {
      videoElement1.requestVideoFrameCallback(drawFrame);
      return;
    }

    // 如果正在进行推理，则跳过当前帧，避免阻塞主线程
    if (isDetecting) {
      videoElement1.requestVideoFrameCallback(drawFrame);
      return;
    }

    isDetecting = true;
    var imageData;
    var ctx = canvasElement1.getContext('2d', { willReadFrequently: true });

    // 只获取 imageData 用于推理，不再把原始视频画到右侧 canvas 上

    // 创建一个离屏 canvas 来提取视频像素数据给模型推理
    const offscreenCanvas = document.createElement('canvas');
    offscreenCanvas.width = canvasElement1.width;
    offscreenCanvas.height = canvasElement1.height;
    const offscreenCtx = offscreenCanvas.getContext('2d', {
      willReadFrequently: true,
    });

    offscreenCtx.drawImage(
      videoElement1,
      0,
      0,
      offscreenCanvas.width,
      offscreenCanvas.height,
    );
    imageData = offscreenCtx.getImageData(
      0,
      0,
      offscreenCanvas.width,
      offscreenCanvas.height,
    );

    await renderResult(imageData, canvasElement1, ctx);

    // 记录上一帧时间
    lastFrameTime = now;
    isDetecting = false;

    // 请求下一帧图像
    videoElement1.requestVideoFrameCallback(drawFrame);
  }

  function canvasToImg(canvas) {
    return new Promise((resolve, reject) => {
      let image = new Image();
      // canvas.toDataURL 返回的是一串Base64编码的URL
      // 指定格式 PNG
      image.src = canvas.toDataURL('image/png');
      image.addEventListener('load', () => {
        resolve(image);
      });
    });
  }

  async function renderResult(img, canvas, ctx) {
    try {
      const poses = await detector?.estimatePoses(img);

      if (poses?.length > 0 && !STATE.isModelChanged) {
        lostFrames = 0;
        // 只有当确信拿到了点位，才清空上一帧的画布并绘制，这样偶尔一两帧的丢失不会造成屏幕闪烁黑块
        if (canvas) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
        drawPerson(ctx, poses[0]);
      } else {
        lostFrames++;
        // 连续5帧没有检测到人，才清空画布（人真的离开了画面）
        if (lostFrames > 5 && canvas) {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
      }
    } catch (err) {
      console.error('---renderResult error:', err);
    }
  }

  function toImag(url) {
    const Img = new Image();
    Img.src = url;
    console.log(Img);
  }

  function base64ToImg(base64str) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = 'data:image/jpeg;base64,' + base64str;
      img.onload = function () {
        resolve(img);
      };
      img.onerror = function (e) {
        reject(e);
      };
    });
  }

  const handleReplay = (e) => {
    e.stopPropagation();
    setIsEnded(false);
    setIsPlaying(true);
    const video = document.getElementById('videotest');
    if (video) {
      video.currentTime = 0;
      video.play().catch((err) => console.error('play error:', err));
    }
  };

  const handleVideoClick = () => {
    const video = document.getElementById('videotest');
    if (!video) return;

    if (video.paused) {
      if (isEnded) {
        setIsEnded(false);
        video.currentTime = 0;
      }
      video.play().catch((err) => console.error('play error:', err));
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  };

  return (
    <Modal
      destroyOnClose
      title={title ?? '视频详情'}
      width={1600}
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      <Card bordered={false}>
        <div id="player" style={{ display: 'flex' }}>
          <div
            style={{
              position: 'relative',
              width: '750px',
              height: '420px',
              cursor: 'pointer',
            }}
            onClick={handleVideoClick}
          >
            <video
              id="videotest"
              style={{ width: '100%', height: '100%' }}
            ></video>
            {!isPlaying && !isEnded && (
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: 10,
                  background: 'rgba(0, 0, 0, 0.6)',
                  borderRadius: '50%',
                  width: '80px',
                  height: '80px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <svg
                  viewBox="0 0 1024 1024"
                  width="40"
                  height="40"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="white"
                    d="M741.042 458.006l-414.933-248.96C291.627 188.331 256 213.12 256 256v497.92c0 42.88 35.627 67.669 70.101 46.955l414.934-248.96c34.474-20.715 34.474-73.195 0-93.909z"
                  />
                </svg>
              </div>
            )}
            {isEnded && (
              <div
                onClick={handleReplay}
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  zIndex: 10,
                  cursor: 'pointer',
                  background: 'rgba(0, 0, 0, 0.6)',
                  borderRadius: '50%',
                  width: '80px',
                  height: '80px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                title="重新播放"
              >
                <svg
                  viewBox="0 0 1024 1024"
                  width="60"
                  height="60"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill="white"
                    d="M682.496 512c0-94.208-76.288-170.496-170.496-170.496-94.208 0-170.496 76.288-170.496 170.496s76.288 170.496 170.496 170.496c42.496 0 81.408-15.36 111.616-41.472l-45.568-45.568c-18.432 14.848-41.472 23.04-66.048 23.04-58.88 0-106.496-47.616-106.496-106.496s47.616-106.496 106.496-106.496 106.496 47.616 106.496 106.496H561.152l96.256 96.256 96.256-96.256h-71.168z"
                  />
                </svg>
              </div>
            )}
          </div>
          <canvas
            id="output"
            style={{ width: '750px', height: '420px' }}
            type="2d"
          ></canvas>
        </div>
      </Card>

      {/* <canvas id="output"
      type="2d"
      width='800'>
      </canvas> */}
    </Modal>
  );
};

export default ModalVideo;
